export const MenuList = [

    {
        title: 'menu.dashboard',
        to: 'home',
        iconStyle: <i className="fa-solid fa-house" />,
        moduleKeys: ['dashboard'],
    },
    {
        title: 'menu.digitalBusinessCards',
        classsChange: 'mm-collapse',
        iconStyle: <i className="fa-solid fa-id-card" />,
        moduleKeys: ['digital-cards'],
        content: [
            {
                title: 'menu.digitalBusinessCardCreate',
                to: 'digital-cards-create',
                moduleKeys: ['digital-card-create'],
            },
            {
                title: 'menu.digitalBusinessCardList',
                to: 'digital-cards',
                moduleKeys: ['digital-card-list'],
            },
        ],
    },
    {
        title: 'menu.meetingsAndTalks',
        classsChange: 'mm-collapse',
        iconStyle: <i className="fa-solid fa-handshake" />,
        moduleKeys: ['calendar', 'my-meetings', 'meeting-requests'],
        content: [
            {
                title: 'menu.calendar',
                to: 'app-calender',
                moduleKeys: ['calendar'],
            },
            {
                title: 'menu.myMeetings',
                to: 'meetings/list',
                moduleKeys: ['my-meetings'],
            },
            {
                title: 'menu.plannedTalks',
                to: 'planned-company-meetings/planned',
                moduleKeys: ['planned-talks'],
            },
            {
                title: 'menu.realizedTalks',
                to: 'planned-company-meetings/realized',
                moduleKeys: ['planned-talks'],
            },
            {
                title: 'menu.meetingRequests',
                to: 'meeting-requests',
                moduleKeys: ['meeting-requests'],
            },
        ],
    },
    {
        title: 'menu.b2bPanel',
        classsChange: 'mm-collapse',
        iconStyle: <i className="fa-solid fa-handshake" />,
        moduleKeys: ['b2b-panel'],
        content: [
            {
                title: 'menu.b2bSessionsApply',
                to: 'sessions',
                moduleKeys: ['sessions'],
            },
            {
                title: 'menu.b2bAnnouncements',
                to: 'announcements',
                moduleKeys: ['user-announcements'],
            },
            {
                title: 'menu.myAppointments',
                to: 'my-appointments',
                moduleKeys: ['my-appointments'],
            },
            {
                title: 'menu.masalar',
                to: 'tables',
                moduleKeys: ['tables'],
            },
        ],
    },
    {
        title: 'menu.messages',
        to: 'messages',
        iconStyle: <i className="fa-solid fa-comments" />,
        moduleKeys: ['messages'],
    },
    {
        title: 'menu.exploreTitle',
        classsChange: 'menu-title',
    },
    {
        title: 'menu.companies',
        classsChange: 'mm-collapse',
        iconStyle: <i className="fa-regular fa-building" />,
        moduleKeys: ['companies'],
        content: [
            {
                title: 'menu.companyListVisitors',
                to: 'company-list?filter=visitor',
                moduleKeys: ['company-list-visitors'],
            },
            {
                title: 'menu.companyListExhibitors',
                to: 'company-list?filter=exhibitor',
                moduleKeys: ['company-list-exhibitors'],
            },
            {
                title: 'menu.companyListBuyerMission',
                to: 'company-list?filter=buyerMission',
                moduleKeys: ['company-list-buyer-mission'],
            },
            {
                title: 'menu.myCompanies',
                to: 'my-companies',
                moduleKeys: ['my-companies'],
            },
            {
                title: 'menu.addCompany',
                to: 'company-add',
                moduleKeys: ['company-create'],
            },
        ],
    },
    {
        title: 'menu.matching',
        to: 'matching',
        iconStyle: <i className="fa-solid fa-handshake" />,
        moduleKeys: ['matching'],
    },
    {
        title: 'menu.products',
        to: 'products',
        iconStyle: <i className="fa-solid fa-box" />,
        moduleKeys: ['products'],
    },
    {
        title: 'menu.needsCreate',
        to: 'needs-create',
        iconStyle: <i className="fa-solid fa-cart-shopping" />,
        moduleKeys: ['needs'],
    },
    {
        title: 'menu.myNeeds',
        to: 'needs',
        iconStyle: <i className="fa-solid fa-list-check" />,
        moduleKeys: ['needs'],
    },
    {
        title: 'menu.lastuserProducts',
        to: 'catalogs',
        iconStyle: <i className="fa-solid fa-book-open" />,
        moduleKeys: ['catalogs'],
    },
    {
        title: 'menu.visitors',
        to: 'visitors',
        iconStyle: <i className="fa-solid fa-users" />,
        moduleKeys: ['visitors'],
    },
    {
        title: 'menu.informationForm',
        classsChange: 'mm-collapse',
        iconStyle: <i className="fa-solid fa-clipboard" />,
        moduleKeys: ['information-form'],
        content: [
            {
                title: 'menu.informationFormAdd',
                to: 'stand-participants-information-form',
                moduleKeys: ['information-form-add'],
            },
            {
                title: 'menu.informationFormList',
                to: 'stand-participants-information-form-list',
                moduleKeys: ['information-form-list'],
            },
        ],
    },
    {
        title: 'menu.eventAndAccountTitle',
        classsChange: 'menu-title',
    },
    {
        title: 'menu.event',
        to: 'event',
        iconStyle: <i className="fa fa-ticket" />,
        moduleKeys: ['event-panel'],
    },
    {
        title: 'menu.socialMaterials',
        to: 'event-materials',
        iconStyle: <i className="fa-solid fa-photo-film" />,
        moduleKeys: ['event-materials'],
    },
    {
        title: 'menu.b2bAdminSection',
        classsChange: 'menu-title',
        moduleKeys: ['b2b-session-create', 'admin-sessions', 'admin-participants', 'admin-announcements', 'admin-appointments', 'admin-meetings', 'admin-tables', 'admin-checkin-survey', 'admin-company-create', 'supplier-day-applications'],
    },
    {
        title: 'menu.b2bSessionCreate',
        to: 'b2b-admin-session-create',
        iconStyle: <i className="fa-solid fa-circle-plus" />,
        moduleKeys: ['b2b-session-create'],
    },
    {
        title: 'menu.b2bSessions',
        to: 'b2b-admin-sessions',
        iconStyle: <i className="fa-solid fa-clone" />,
        moduleKeys: ['admin-sessions'],
    },
    {
        title: 'menu.b2bParticipants',
        to: 'b2b-admin-participants',
        iconStyle: <i className="fa-solid fa-user-group" />,
        moduleKeys: ['admin-participants'],
    },
    // {
    //     title: 'menu.b2bAdminMatches',
    //     to: 'b2b-admin-matches',
    //     iconStyle: <i className="fa-solid fa-shuffle" />,
    // },
    {
        title: 'menu.b2bAnnouncements',
        to: 'b2b-admin-announcements',
        iconStyle: <i className="fa-solid fa-bullhorn" />,
        moduleKeys: ['admin-announcements'],
    },
    {
        title: 'menu.adminAppointments',
        to: 'b2b-admin-appointments',
        iconStyle: <i className="fa-solid fa-calendar-check" />,
        moduleKeys: ['admin-appointments'],
    },
    {
        title: 'menu.adminMeetings',
        to: 'b2b-admin-meetings',
        iconStyle: <i className="fa-solid fa-handshake" />,
        moduleKeys: ['admin-meetings'],
    },
    {
        title: 'menu.adminTables',
        to: 'b2b-admin-tables',
        iconStyle: <i className="fa-solid fa-table-cells-large" />,
        moduleKeys: ['admin-tables'],
    },
    {
        title: 'menu.b2bAdminCheckinSurvey',
        to: 'b2b-admin-checkin-survey',
        iconStyle: <i className="fa-solid fa-qrcode" />,
        moduleKeys: ['admin-checkin-survey'],
    },
    {
        title: 'menu.b2bAdminCompanyCreate',
        to: 'b2b-admin-company-create',
        iconStyle: <i className="fa-regular fa-building" />,
        moduleKeys: ['admin-company-create'],
    },
    {
        title: 'menu.supplierDayApplications',
        to: 'supplier-day-applications',
        iconStyle: <i className="fa-regular fa-rectangle-list" />,
        moduleKeys: ['supplier-day-applications'],
    },
    {
        title: 'menu.b2bLiveBoard',
        to: 'b2b-admin-live-board',
        iconStyle: <i className="fa-solid fa-tv" />,
    },
]
